import { AnchorIcon, CraneIcon, PlanningIcon, Star06Icon, type SvgIcon, TransshipmentIcon } from "@pharaday/lighthouse";

export enum ApplicationTypeEnum {
  PORT = "PORT",
  CHARTERER = "CHARTERER",
  TRANSHIPMENT = "TRANSHIPMENT",
  SMART_SEARCH = "SMART_SEARCH",
  PORT_CALL = "PORT_CALL",
  TERMINAL = "TERMINAL",
}

export const mapApplicationTypeToIcon: Record<ApplicationTypeEnum, SvgIcon> = {
  [ApplicationTypeEnum.PORT]: AnchorIcon,
  [ApplicationTypeEnum.CHARTERER]: PlanningIcon,
  [ApplicationTypeEnum.TRANSHIPMENT]: TransshipmentIcon,
  [ApplicationTypeEnum.SMART_SEARCH]: Star06Icon,
  [ApplicationTypeEnum.PORT_CALL]: AnchorIcon,
  [ApplicationTypeEnum.TERMINAL]: CraneIcon,
};
